import { Component, inject, OnInit, input, output } from '@angular/core';
import {
  ControlContainer,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { WcgErrorComponent } from '@wcg/frontend-framework';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DocumentType } from '@documents/models';
import { NgClass } from '@angular/common';
import { REVIEWER_MATERIAL_MAX_FILE_SIZE_MB } from '@data-access/submissions/constants';

@Component({
  selector: 'wcg-upload-reviewer-material-row',
  imports: [
    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    MatButtonModule,
    ReactiveFormsModule,
    WcgErrorComponent,
    MatTooltipModule,
    NgClass,
  ],
  templateUrl: './upload-reviewer-material-row.component.html',
  styleUrl: './upload-reviewer-material-row.component.css',
})
export class WcgUploadReviewerMaterialRowComponent implements OnInit {
  public readonly _controlContainer = inject(ControlContainer);

  readonly maxFileSizeMb = REVIEWER_MATERIAL_MAX_FILE_SIZE_MB;

  readonly errorMessage = input('');
  readonly documentTypes = input<DocumentType[]>([]);
  readonly documentNameInput = input('');
  readonly isLast = input(false);

  readonly handleDeleteFile = output<void>();
  dropdownOptions: string[] = [];
  fileControl: FormControl = new FormControl();

  fileForm?: FormGroup;

  get fileName() {
    return this.file?.value?.name;
  }

  get file() {
    return this.fileForm?.get('file');
  }

  get documentType() {
    return this.fileForm?.get('documentType');
  }

  get questionId() {
    return this.fileForm?.get('questionId');
  }

  ngOnInit() {
    this.fileForm = this._controlContainer?.control as FormGroup;
  }

  deleteFile() {
    // TODO: The 'emit' function requires a mandatory void argument
    this.handleDeleteFile.emit();
  }
}
